<template>
  <div class="body-content">
    <!-- <ToolBar /> -->
    <div></div>
    <div class="content-right-out">
      <div class="content-tool-bar"><HeaderToolBar /></div>
      <div class="content-router" id="content-router-dom">
         <div id="to-top">
        <a-back-top :target ="bindToTop">
          <div class="ant-back-top-inner">UP</div>
        </a-back-top>
      </div>
        <router-view/>
      </div>
    </div>
    <div id="model-area">
      <div id="shortcut">
        <a-modal
          v-model="showShortCut"
          @ok="openShortcut"
          centered
          footer=""
          :closable="false"
        >
          <div id="search-input" class="center-all">
            <a-input-search
              placeholder="让访问，更快一些！"
              enter-button="一键开启"
              size="large"
              v-model="shortcut"
              @search="openShortcut"
              ref="test"
            />
          </div>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
import ToolBar from "../components/main/toolBar.vue";
import HeaderToolBar from "../components/HeaderToolBar.vue";
export default {
  data() {
    return {
      showShortCut: false,
      shortcut: "",
    };
  },
  methods: {
    openShortcut() {
      if (this.shortcut) {
        this.$req.formDataPost(
          "/api/favorites/search/shortcut",
          { shortcut: this.shortcut },
          (res) => {
            if (res.data) {
             let newWindow = window.open(res.data.url);
              newWindow.opener = null;
              this.showShortCut = false;
            } else {
              this.$message.warn("没有找到该快捷指令！");
            }
            this.shortcut = "";
          }
        );
      } else {
        this.showShortCut = false;
      }
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.test.focus();
      });
    },
    bindToTop(){
      return document.getElementById("content-router-dom");
    }
  },
  components: { ToolBar, HeaderToolBar },
  created() {
    let that = this;
    document.onkeydown = function () {
      var oEvent = window.event;
      //ctrl+q
      if (oEvent.ctrlKey && oEvent.keyCode == 81) {
        that.showShortCut = true;
        that.focus();
      }
    };
    this.$req.get("/api/user/info", {}, (res) => {
      this.$store.commit("initUser", res.data);
    });
  },
};
</script>

<style scoped>
.body-content {
  background: #f8fafb;
  display: flex;
  height: auto;
}
.content-right-out {
  width: 100%;
}
.content-tool-bar {
  height: 67px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.content-router {
  margin-left: 20px;
  margin-top: 20px;
  overflow-y: scroll;
  height: calc(100vh - 80px - 20px);
}
.content-router::-webkit-scrollbar {
  display: none;
}
.ant-modal-content {
  border-radius: 5px !important;
}
#to-top .ant-back-top {
  bottom: 100px;
}
#to-top .ant-back-top-inner {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #1088e9;
  color: #fff;
  text-align: center;
  font-size: 20px;
}
</style>